export function equalToMatcherContext(ruleAttr) {
    return function equalToMatcher(runtimeAttr) {
        var isEqual = runtimeAttr === ruleAttr;
        return isEqual;
    };
}
